/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Document_Analysis_ResultsInputs */

const en_page_title_document_analysis_results = /** @type {(inputs: Page_Title_Document_Analysis_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document analysis results`)
};

const nl_page_title_document_analysis_results = /** @type {(inputs: Page_Title_Document_Analysis_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultaten documentanalyse`)
};

/**
* | output |
* | --- |
* | "Document analysis results" |
*
* @param {Page_Title_Document_Analysis_ResultsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_document_analysis_results = /** @type {((inputs?: Page_Title_Document_Analysis_ResultsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Document_Analysis_ResultsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_document_analysis_results(inputs)
	return en_page_title_document_analysis_results(inputs)
});